export default __webpack_public_path__ + "static/media/auroracoin.3ea42256.png";